import React, {useState, useEffect} from 'react'
import millify from 'millify';
import {Link} from 'react-router-dom';
import {Card, Row, Col, Input, Typography} from 'antd';
import Loader from './loader'

import {useGetCryptosQuery} from '../service/cryptoApi'

const CryptoCurrencies = ({simplified}) => {
    const count = simplified ? 10 : 100;
    const {data: cryptosList, isFetching} = useGetCryptosQuery(count);
    const [cryptos, setCryptos] = useState([]);
    const [search, setSearch] = useState('')
    const {Title} = Typography;

    useEffect(() =>{
        const filteredCrypto = cryptosList?.data?.coins.filter(coin => coin.name.toLowerCase().includes(search.toLowerCase()));

        setCryptos(filteredCrypto);

    }, [cryptosList, search])

    if(isFetching) return <Loader />
    return (
        <>
        {!simplified && <Title level={3}>Crypto News</Title>}
        {!simplified && <div className="search-crypto">
            <Input placeholder="Search crypto" value={search} onChange={e => setSearch(e.target.value)}/>
        </div>}
        <Row gutter={[32,32]} className="crypto-card-container">
            {cryptos?.map((crypto) => (
                <Col xs={24} sm={12} lg={6} className="crypto-card" key={crypto.id}>
                    <Link to={`/crypto/${crypto.id}`}>
                        <Card 
                            title={`${crypto.rank}. ${crypto.name}`}
                            extra={<img className="crypto-image" alt={crypto.name} src={crypto.iconUrl}/>}
                            hoverable
                        >
                            <p>Price: ${millify(crypto.price)}</p>
                            <p>Market Cap: ${millify(crypto.marketCap)}</p>
                            <p>Daily Change: {millify(crypto.change)}%</p>
                        </Card>
                    </Link>
                </Col>
            ))}
        </Row>
        </>
    )
}

export default CryptoCurrencies
